import { AppState } from '../reducers/RootReducer';
import { createSelector } from 'reselect';
import { IExercise } from '../models/Models';

const getExercises = (state: AppState): Array<IExercise> => state.exercises.exercises;

export const getExercisesSelector = createSelector(getExercises, (exercises) => exercises);
